// extracted by mini-css-extract-plugin
export default {"analysis":"Analysis_analysis__38Cz6"};